module.exports = __webpack_public_path__ + "img/log.6ce960e3.svg";